export class Utils {
	getCreditCardYears () {
		var year = parseInt(new Date().getFullYear())

		return this.rangeArray(year, year + 15).map(function (_, i) { return {year: _} })
	}

	getCreditCardMonths () {
		return this.rangeArray(1, 12).map(function (_, i) {
			if (_ <= 9) { _ = '0' + _ };
			return { month: _ }
		})
	}

	rangeArray (a, b, step) {
		var A = []
		if (typeof a === 'number') {
			A[0] = a
			step = step || 1
			while (a + step <= b) {
				A[A.length] = a += step
			}
		} else {
			var s = 'abcdefghijklmnopqrstuvwxyz'
			if (a === a.toUpperCase()) {
				b = b.toUpperCase()
				s = s.toUpperCase()
			}
			s = s.substring(s.indexOf(a), s.indexOf(b) + 1)
			A = s.split('')
		}
		return A
	}
};
